import { MessageSection } from './FormattedMessageContent.types';

export const formatMessageContent = (content: string): MessageSection[] => {
    if (!content) return [];

    const lines = content.split('\n').filter(line => line.trim() !== '');

    const hasBulletPoints = lines.some(line =>
        line.trim().startsWith('-') ||
        line.trim().startsWith('•') ||
        line.trim().startsWith('*')
    );

    const formattedContent: MessageSection[] = [];
    let currentList: string[] = [];
    let currentParagraph: string[] = [];

    lines.forEach((line) => {
        const trimmedLine = line.trim();

        if (trimmedLine.startsWith('-') || trimmedLine.startsWith('•') || trimmedLine.startsWith('*')) {
            if (currentParagraph.length > 0) {
                formattedContent.push({
                    type: 'paragraph',
                    content: currentParagraph.join(' ')
                });
                currentParagraph = [];
            }

            const bulletContent = trimmedLine.replace(/^[-•*]\s*/, '').trim();
            currentList.push(bulletContent);
        } else {
            if (currentList.length > 0) {
                formattedContent.push({
                    type: 'list',
                    items: [...currentList]
                });
                currentList = [];
            }

            currentParagraph.push(trimmedLine);
        }
    });

    if (currentList.length > 0) {
        formattedContent.push({
            type: 'list',
            items: currentList
        });
    }
    if (currentParagraph.length > 0) {
        formattedContent.push({
            type: 'paragraph',
            content: currentParagraph.join(' ')
        });
    }

    return formattedContent;
};
